<template>
  <RangeSlider
    :aria-label="$t('dictionary.price')"
    :min-val="minRange"
    :max-val="maxRange"
    :values="paramsValues"
    :step="currency.step"
    :label-prefix="currency.symbol"
    :locale="locale"
    @current-value="setPriceRange"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import RangeSlider from '@sephora-asia/core-range-slider/RangeSlider.vue'
import i18n from '../mixins/i18n'
import queryString from '../mixins/queryString'

export default {
  name: 'PriceRangeFilterContainer',
  components: {
    RangeSlider
  },
  mixins: [i18n, queryString],
  props: {
    minRange: {
      type: Number,
      required: true
    },
    maxRange: {
      type: Number,
      required: true
    },
    isReset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      minValue: this.minRange,
      maxValue: this.maxRange
    }
  },
  computed: {
    ...mapGetters({
      currency: 'globalConfig/currency',
      showViewResultsCTAButton: 'listingPageFilters/showViewResultsCTAButton'
    }),

    paramsValues() {
      return [this.minValue, this.maxValue]
    },

    locale() {
      return this.$i18n.acceptLanguage
    }
  },
  watch: {
    isReset(newVal, _oldVal) {
      if (newVal) {
        this.resetValues()
        this.$emit('resetted')
      }
    },
    minRange() {
      this.resetValues()
    },
    maxRange() {
      this.resetValues()
    }
  },
  created() {
    this.checkParams()
  },
  methods: {
    checkParams() {
      const query = { ...this.$route.query }
      let rearrangeUrl = true
      if (!query['min-price'] && !query['max-price']) rearrangeUrl = false
      // setting the query params value to minValue and maxValue
      // that will be reflected in the RangeSlider
      if (query['min-price'] > this.minRange) {
        this.minValue = Number(query['min-price'])
        rearrangeUrl = false
      }
      if (query['max-price'] < this.maxRange) {
        this.maxValue = Number(query['max-price'])
        rearrangeUrl = false
      }
      if (rearrangeUrl) this.setParamsValues()
    },
    setPriceRange(values) {
      // do nothing if selected values don't change
      if (values.toString() === this.paramsValues.toString()) return
      // if View Results CTA Button is already displayed do nothing
      if (!this.showViewResultsCTAButton) {
        this.$store.commit(
          'listingPageFilters/setShowViewResultsCTAButton',
          true
        )
      }
      this.minValue = values[0]
      this.maxValue = values[1]
      this.setParamsValues()
      this.trackPriceChangeEvent()
    },
    setParamsValues() {
      const params = { page: undefined }
      // remove params if the minValue is less or equal to the minRange else add min price params
      if (
        isNaN(this.minValue) ||
        this.minValue < 0 ||
        this.minValue <= this.minRange
      ) {
        params['min-price'] = undefined
      } else if (this.minValue) {
        // This is to prevent cases of 1.20000000001
        params['min-price'] = Number.isInteger(this.minValue)
          ? this.minValue.toFixed()
          : this.minValue.toFixed(2)
      }

      // remove params if the minValue is less or equal to the minRange else add max price params
      if (
        isNaN(this.maxValue) ||
        this.maxValue < 0 ||
        this.maxValue >= this.maxRange
      ) {
        params['max-price'] = undefined
      } else if (this.maxValue) {
        // This is to prevent cases of 1.20000000001
        params['max-price'] = Number.isInteger(this.maxValue)
          ? this.maxValue.toFixed()
          : this.maxValue.toFixed(2)
      }
      this.sortAndBuildUrlQuery(params)
    },
    trackPriceChangeEvent() {
      const cm8 =
        (isNaN(this.minValue) ||
          this.minValue < 0 ||
          this.minValue <= this.minRange) &&
        (isNaN(this.maxValue) ||
          this.maxValue < 0 ||
          this.maxValue >= this.maxRange)
          ? -1
          : 1

      this.$analytics.trackEvent('click', {
        params: {
          event_category: 'Filters',
          event_action: 'Click price Filter',
          event_label: `from-${this.minValue}-to-${this.maxValue}`,
          cm8
        }
      })
    },
    resetValues() {
      this.minValue = this.minRange
      this.maxValue = this.maxRange
    }
  }
}
</script>
